import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import Card from '@dashboard/components/Card';
import CardContent from '@dashboard/components/CardContent';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { Alert, AlertTitle, AlertDescription } from '@dashboard/components/ui/alert';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import EmptyState from '@dashboard/components/EmptyState';
import { chargeInvoicesKey } from '@dashboard/lib/queryKeys';
import { DataGrid } from '@dashboard/components/DataGrid';
import { getInvoiceColumns } from '@dashboard/components/InvoiceColumns';
import CardHeader from '@/dashboard/components/CardHeader';
import CardHeaderTitle from '@/dashboard/components/CardHeaderTitle';

const PaymentsChargesDetailInvoices = ({ payment }) => {
  const { sellerId, token } = useAuth();

  const {
    data: invoices,
    isLoading,
    isError,
  } = useQuery({
    queryKey: chargeInvoicesKey(payment._id),
    queryFn: () => fetcher(`/sellers/${sellerId}/charges/${payment._id}/invoices`, token),
    enabled: !!payment._id,
  });

  const columns = useMemo(() => getInvoiceColumns(), []);
  const emptyState = (
    <EmptyState>
      <EmptyState.Subtitle>No invoices found for this payment.</EmptyState.Subtitle>
    </EmptyState>
  );

  return (
    <div className="flex flex-col lg:flex-row items-start justify-center">
      <div className="order-2 lg:order-1 w-full lg:pr-8 px-4 pt-2">
        <Card className="mx-auto !px-0 !py-2">
          <CardHeader className="mb-4">
            <CardHeaderTitle>Invoices</CardHeaderTitle>
          </CardHeader>
          <CardContent>
            {isError ? (
              <Alert variant="destructive" className="my-4">
                <ExclamationCircleIcon />
                <AlertDescription>Failed to load invoices</AlertDescription>
              </Alert>
            ) : (
              <DataGrid
                columns={columns}
                data={invoices ?? []}
                isLoading={isLoading}
                emptyState={emptyState}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentsChargesDetailInvoices;
